import script from "./ChallengeUnitCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ChallengeUnitCard.vue?vue&type=script&setup=true&lang=js"

import "./ChallengeUnitCard.vue?vue&type=style&index=0&id=c53f5a5c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c53f5a5c"]])

export default __exports__